import React from "react";
import accuracyImage from "../../assets/accuracy.png";

const features = [
  "Real Time Reporting Dashboard",
  "Fuel Filled Report",
  "Fuel Theft Report",
  "Fuel Graphical Report",
  "Mileage Report",
  "Consumption Report",
  "Instant Alerts",
  "And many more reports",
];

export default function FuelMonitoringSection() {
  return (
    <section className="bg-white py-12 sm:py-16 lg:py-24">
      <div className="mx-auto grid max-w-[1300px] items-center gap-10 px-6 lg:grid-cols-2 lg:gap-12">
        
        {/* Left Content */}
        <div className="text-center lg:text-left">
          <h2 className="text-3xl font-bold leading-tight text-[#111] sm:text-4xl lg:text-5xl">
            India's most accurate Fuel
            {/* Hide the break on mobile so the text wraps naturally */}
            <br className="hidden lg:block" /> Monitoring System
          </h2>

          <p className="mx-auto mt-4 max-w-[560px] text-base leading-relaxed text-gray-600 sm:mt-6 sm:text-lg lg:mx-0">
            Experience unparalleled precision with Veyonta Track Technology’s
            Fuel Monitoring System. Engineered with advanced sensors, our
            solution guarantees industry-leading accuracy while ensuring every
            drop of fuel is accounted for.
          </p>

          {/* Features List Container */}
          <div className="mx-auto mt-8 grid max-w-[560px] grid-cols-1 gap-x-6 gap-y-4 text-left sm:grid-cols-2 lg:mx-0 lg:mt-10 lg:gap-x-8">
            {features.map((item) => (
              <div key={item} className="flex items-start gap-3 sm:items-center">
                {/* shrink-0 prevents the circle from squishing on very small screens */}
                <div className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#df8b2d] text-xs font-bold text-white sm:mt-0">
                  ✓
                </div>
                <span className="text-sm font-medium text-gray-700 sm:text-base">
                  {item}
                </span>
              </div>
            ))}
          </div>

          <button className="mt-8 rounded-lg bg-[#df8b2d] px-8 py-3 text-sm font-medium text-white transition hover:bg-[#c9781f] sm:text-base lg:mt-10">
            Fuel Automation
          </button>
        </div>

        {/* Right Image */}
        <div className="mt-8 flex justify-center lg:mt-0 lg:justify-end">
          <img
            src={accuracyImage}
            alt="Fuel Monitoring Accuracy"
            className="w-full max-w-[400px] object-contain sm:max-w-[500px] lg:max-w-[620px]"
          />
        </div>
        
      </div>
    </section>
  );
}